// Copyright (c) 2023 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import "modernizr";
import * as React from "react";
import { connect } from "react-redux";
import { WrappedComponentProps, injectIntl } from "react-intl";

import { IState } from "states/states";
import { IAction } from "actions";
import cssContent from "content.scss";

interface IProgressBarExtProps {
  value: string;
  percentage: number;
  unit: string;
  tooltip?: string;
  disabled?: boolean;
}

interface IProgressBaProps {}

const mapStateToProps = (state: IState, ownProps: IProgressBarExtProps) => {
  const props: IProgressBaProps = {};
  return props;
};

interface IProgressBarDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IProgressBarDispatch = {};
  return dispatchProps;
};

class ProgressBarComponent extends React.Component<
  IProgressBaProps & IProgressBarExtProps & IProgressBarDispatch & WrappedComponentProps
> {
  public render() {
    return (
      <div style={{ display: "flex" }} title={this.props.tooltip}>
        <div className="progressBarContainer">
          <div
            className="progressBar"
            style={{
              backgroundColor:
                this.props.disabled === true ? cssContent.POWERPROGRESS_GRAYED_OUT : undefined,
              width:
                String(
                  this.props.percentage > 100
                    ? 100
                    : this.props.percentage < 0
                    ? 0
                    : this.props.percentage,
                ) + "%",
            }}
          ></div>
          <div className="progressBarText">{this.props.value}</div>
        </div>
        <div className="progressBarUnit">{this.props.unit}</div>
      </div>
    );
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ProgressBarComponent));
